<template>
    <span class="control-icon">
        <svg v-if="muted" xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">
            <defs>
                <filter id="zchvh3877a" width="147.9%" height="147.9%" x="-24%" y="-24%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                    <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"/>
                        <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                </filter>
            </defs>
            <g fill="none" fill-rule="evenodd" filter="url(#zchvh3877a)" transform="translate(20 20)">
                <circle cx="24" cy="24" r="24" stroke="#FFF"/>
                <path fill="#FFF" d="M18 25.48c.276 0 .5.225.5.5 0 2.97 2.406 5.376 5.375 5.376 2.209 0 4.107-1.333 4.933-3.238l.752.751c-.964 1.893-2.846 3.24-5.06 3.456v2.702h.924c.276 0 .5.224.5.5 0 .246-.177.45-.41.492l-.09.009h-2.786c-.276 0-.5-.224-.5-.5 0-.246.177-.45.41-.492l.09-.008.862-.001v-2.682c-3.346-.194-6-2.97-6-6.364 0-.276.224-.5.5-.5zm2.447-5.722l6.665 6.666c-.344 1.498-1.686 2.616-3.29 2.616-1.863 0-3.374-1.51-3.374-3.375l-.001-5.907zm9.303 5.723c.276 0 .5.224.5.5 0 .452-.047.894-.137 1.32l-.88-.88c.011-.145.017-.292.017-.44 0-.276.224-.5.5-.5zm-5.927-11.107c1.864 0 3.375 1.51 3.375 3.375l-.001 6.638-6.747-6.747.003-.077c.096-1.778 1.568-3.19 3.37-3.19z"/>
                <path fill="#FFF" d="M23 0H24.5V48H23z" transform="rotate(-45 23.75 24)"/>
            </g>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">
            <defs>
                <filter id="xcqnw5fzaa" width="147.9%" height="147.9%" x="-24%" y="-24%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                    <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"/>
                        <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                </filter>
            </defs>
            <g fill="none" fill-rule="evenodd" filter="url(#xcqnw5fzaa)" transform="translate(20 20)">
                <circle cx="24" cy="24" r="24" stroke="#FFF"/>
                <g transform="translate(18 14.057)">
                    <rect width="6.75" height="14.667" x="2.448" y=".374" fill="#FFF" rx="3.375"/>
                    <path stroke="#FFF" stroke-linecap="round" d="M0 11.98c0 3.245 2.63 5.876 5.875 5.876s5.875-2.63 5.875-5.875M6 18.1L6 21.528M4.638 21.528L7.424 21.528"/>
                </g>
            </g>
        </svg>
        <i>
            {{ muted ? 'Unmute audio' : 'Mute audio'}}
        </i>
    </span>
</template>

<script>
export default {
    name: 'audio-play-mute',

    props: {
        muted: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>